/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Button,
  CloseIcon,
  Flex,
  Link,
  Text,
  Title,
} from '@bottlebooks/gatsby-theme-base/src';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { Trans } from '@lingui/macro';
import Dialog from '@reach/dialog';
import '@reach/dialog/styles.css';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { jsx } from 'theme-ui';
import EducationalContentDialog, {
  useEducationalContentDialog,
} from '@bottlebooks/gatsby-plugin-bookmarks/src/components/EducationalContentDialog';
import { useLoginDialog } from './useAuthentication';

export default function LoginDialog() {
  const [isOpen, setIsOpen] = useLoginDialog();
  const { shouldShow: shoudShowEducationalContent, setHasBeenShown } =
    useEducationalContentDialog();

  function closeDialog() {
    setIsOpen(false);
  }
  function onSignOn() {
    setIsOpen(false);
  }

  if (!isOpen) return null;

  // Educational content should be displayed only 1 time
  // It should always have a link to login
  if (shoudShowEducationalContent)
    return <EducationalContentDialog closeDialog={closeDialog} />;

  return <LoginDialogProviders closeDialog={closeDialog} onSignIn={onSignOn} />;
}

function LoginDialogProviders({ closeDialog, onSignIn }) {
  const link = useLink();
  const auth = getAuth(getApp());
  const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // We will display Google as auth provider.
    signInOptions: ['google.com', 'password'],
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: () => {
        onSignIn();
      },
    },
  };
  return (
    <Dialog
      onDismiss={closeDialog}
      aria-label="login"
      sx={{
        width: ['100vw', 600],
        marginY: [0, '10vh'],
        position: 'relative',
      }}
    >
      <Button
        variant="text"
        onClick={closeDialog}
        sx={{ position: 'absolute', top: 2, right: 2 }}
      >
        <CloseIcon size="xsmall" />
      </Button>
      <Flex
        direction="column"
        justify="center"
        align="center"
        sx={{ marginY: 4, width: '100%' }}
      >
        <Title variant="small">
          <Trans>Get the most out of your visit</Trans>
        </Title>
        <Text sx={{ marginTop: 2 }}>
          <Trans>Log in to create your tasting list for this event.</Trans>
        </Text>
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={auth}
          sx={{ marginTop: 3 }}
        />
        {/* Hard coding this for now. Should have a dependency from here into gatsby-theme-event useLink? */}
        <Link to={link.bookmarks()} onClick={closeDialog}>
          <Text sx={{ marginTop: 4 }}>
            <Trans>Learn more about the features of this website</Trans>
          </Text>
        </Link>
      </Flex>
    </Dialog>
  );
}
